import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TableDataLayer from "../components/TableDataLayer";

// Dedicated "Informative Calls" page. Reuses the main complaints list UI but
// renders it in informativeOnly mode, so it fetches from
// /get-informative-complaints and shows ONLY complaints flagged informative:true.
const TableDataPageInformative = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Simple heading (no "add" button — this is a read/list surface) */}
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
          <h6 className="fw-semibold mb-0">Informative Calls</h6>
        </div>

        {/* Same list UI as Complaints List, filtered to informative:true */}
        <TableDataLayer informativeOnly={true} />
      </MasterLayout>
    </>
  );
};

export default TableDataPageInformative;
